import LoadingBox from 'components/Common/Loading/LoadingBox'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextButtonLoadingSkeleton from 'LuxKit/Button/TextButtonLoadingSkeleton'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import Group from 'components/utils/Group'
import React from 'react'
import styled from 'styled-components'
import _SearchTileBase from './_SearchTileBase'
import _SearchTileContent from './_SearchTileContent'
import _SearchTileContentSecondary from './_SearchTileContentSecondary'
import _SearchTilePricing from './_SearchTilePricing'
import OfferDescriptionLoadingSkeleton from 'components/Common/Loading/OfferDescriptionLoadingSkeleton'
import { useAppSelector } from 'hooks/reduxHooks'
import getOfferListKey from 'lib/offer/offerListKey'
import { useShouldShowOfferDescription } from 'lib/offer/offerDescriptionUtils'

const Primary = styled(Group)`
  grid-area: content-primary;
`

const Hero = styled(LoadingBox)`
  grid-area: hero;
`

interface Props {
  filters?: App.OfferListFilters
  offerPosition?: number
  className?: string
}

function LoadingSearchTileSkeleton({ filters, offerPosition, className }: Props) {
  const descriptionLoading = useAppSelector((state) => state.offer.offerLists[filters ? getOfferListKey(filters) : '']?.descriptionLoading)
  const shouldShowDescription = useShouldShowOfferDescription(offerPosition, descriptionLoading)
  const offerDescBanner = shouldShowDescription ? <OfferDescriptionLoadingSkeleton position={offerPosition} /> : false

  return <_SearchTileBase banner={offerDescBanner} className={className}>
    <Hero />
    <_SearchTileContent>
      <Primary direction="vertical" gap={12}>
        <VerticalSpacer gap={4}>
          <TextLoadingBox typography="body-small" width="20ch" />
          <TextLoadingBox typography="heading5" width="100%" lines={2} />
          <TextLoadingBox typography="body-medium" width="80%" />
        </VerticalSpacer>
      </Primary>
      <_SearchTileContentSecondary>
        <_SearchTilePricing
          action={<TextButtonLoadingSkeleton width="10ch" />}
        >
        </_SearchTilePricing>
      </_SearchTileContentSecondary>
    </_SearchTileContent>
  </_SearchTileBase>
}

export default LoadingSearchTileSkeleton
